import React from 'react';
import { number } from 'prop-types';
const EditIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_303_25142" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.850708H19.0046V20.856H0V0.850708Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_303_25142)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5565 20.856H3.44751C1.54651 20.856 -0.000488281 19.2276 -0.000488281 17.2265V4.48018C-0.000488281 2.47913 1.54651 0.850708 3.44751 0.850708H13.0325C13.4855 0.850708 13.8515 1.23702 13.8515 1.71281C13.8515 2.18966 13.4855 2.57597 13.0325 2.57597H3.44751C2.45051 2.57597 1.63851 3.42966 1.63851 4.48018V17.2265C1.63851 18.277 2.45051 19.1307 3.44751 19.1307H15.5565C16.5545 19.1307 17.3655 18.277 17.3655 17.2265V7.44123C17.3655 6.96545 17.7325 6.57913 18.1845 6.57913C18.6375 6.57913 19.0045 6.96545 19.0045 7.44123V17.2265C19.0045 19.2276 17.4575 20.856 15.5565 20.856Z"
        fill="#AAA2AA"
      />
    </g>
    <mask id="mask1_303_25142" maskUnits="userSpaceOnUse" x="8" y="0" width="13" height="13">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.10107 0.000488281H20.0171V12.5439H8.10107V0.000488281Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_303_25142)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62307 12.5439L8.16207 12.4786L8.10107 10.9418L18.1791 0.331278C18.6001 -0.109775 19.2821 -0.109775 19.7021 0.331278C20.1231 0.774436 20.1231 1.49233 19.7021 1.93444L9.62307 12.5439Z"
        fill="#AAA2AA"
      />
    </g>
  </svg>
);

EditIcon.defaultProps = {
  width: 21,
  height: 22,
};

EditIcon.propTypes = {
  width: number,
  height: number,
};

export default EditIcon;
